<div class="confirm-dialog">
  <div class="img-container"><img [src]="image" alt="qr code" /></div>

  <button (click)="downloadQrCode(image)" class="ibexfusion-raised-button" mat-button type="button">{{ download }}</button>
  <button (click)="dialogRef.close(null)" class="ibexfusion-raised-button" mat-button type="button">{{ close }}</button>
</div>
